import request from "@/utils/request";

export function getStoreOrderList(params) {
  return request({
    url: "/trade/order/h5/sales-center/page",
    method: "get",
    params,
  });
}
